// tslint:disable: member-ordering
import { Component, ComponentRef, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ConnectToApicryptComponent } from 'src/app/pages/user/mss/inbox/connect-to-apicrypt/connect-to-apicrypt.component';
import { ConnectToMailizComponent } from 'src/app/pages/user/mss/inbox/connect-to-mailiz/connect-to-mailiz.component';
import { IDENTIFIANT_NATIONAL_KEY, MailizAccount, SelectedAccount } from 'src/app/pages/user/mss/inbox/mss.component';
import { identifiantNationalKey, idnatStructureSettingKey, nomSettingKey, nomStructureSettingKey, practiceSettingKey, prenomSettingKey, professionSettingKey, typeStructureSettingKey } from 'src/app/services/dmp/dmp.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { MssServiceFactory, MssTypeService } from 'src/app/services/mss/mss-service.factory';
import { RessourceService } from 'src/app/services/ressource/ressource.service';
import { EmailAuthent } from 'src/app/utils/interfaces/new/mss-email-authent.interface';
import { Profil } from 'src/app/utils/interfaces/new/profil.interface';
import { RessourceSetting, RessourceTypeEnum } from 'src/app/utils/interfaces/new/RessourceSetting';
import { NgSelectAccount } from '../quick-send-mss/quick-send-mss.fragment';
import { environment } from 'src/environments/environment';

enum HandleCHandleMssModalStateEnum {
  selectAccount,
  loginAccount,
  otp,
}

export interface MssConnectionOk extends EmailAuthent {
  provider: MssTypeService;
}

@Component({
  selector: 'app-handle-mss-modal',
  templateUrl: './handle-mss-modal.component.html',
  styleUrls: [
    './handle-mss-modal.component.scss',
    '../modal.fragment.scss'
  ]
})
export class HandleMssModalComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @Output() public closeEmitter = new EventEmitter<MssConnectionOk | undefined>();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (this.modalBody && !this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  public isPending = false;
  public currentState: HandleCHandleMssModalStateEnum = HandleCHandleMssModalStateEnum.selectAccount;
  public currentStateTemplate = HandleCHandleMssModalStateEnum;
  public accountForm: FormGroup;
  private _currentProfil: Profil;
  private _idNat: string;
  public accounts: Array<NgSelectAccount> = [];
  public get accountSelected(): SelectedAccount {
    return this._accountSelected;
  }
  public set accountSelected(account: SelectedAccount) {
    this._mssSrv.switchService(account.provider);
    this._accountSelected = account;
    this._lastProviderSelected = account.provider;
  }
  private _accountSelected: SelectedAccount;
  private _lastProviderSelected: MssTypeService;
  public isMSSSet: boolean;
  private _selectedIdNat: string;

  constructor(
    private _formBuilder: FormBuilder,
    private _resourceSrv: RessourceService,
    private _mssSrv: MssServiceFactory,
    private _modalSrv: ModalService,
    private _viewCtnRef: ViewContainerRef
  ) { }

  ngOnInit(): void {
    this._initAccounts();
  }

  private async _initAccounts(): Promise<void> {
    try {
      const currentProfilStr = localStorage.getItem('currentProfil');
      let params: Array<RessourceSetting>;
      if (currentProfilStr && currentProfilStr !== '') {
        this._currentProfil = JSON.parse(currentProfilStr);
        params = await this._resourceSrv.getResourceSettings(this._currentProfil.id, 'profil');
        const identifiantNationalSetting = this._resourceSrv.getSettingFromArray(params, IDENTIFIANT_NATIONAL_KEY);
        this._idNat = identifiantNationalSetting ? identifiantNationalSetting.value : '';
      }

      if (this._currentProfil) {
        try {
          const settings = await this._resourceSrv.getResourceSettings(this._currentProfil.id, 'profil');
          const addressesStr = this._getSettings(settings, 'mailiz_account');
          if (addressesStr && addressesStr !== '') {
            const addresses: Array<MailizAccount> = JSON.parse(addressesStr);
            for (const address of addresses) {
              this.addAccountsToList(MssTypeService.mailiz, address.addresses, address.idnat);
            }
          }
        } catch (e) {
          console.error(e);
        }

        try {
          this._mssSrv.switchService(MssTypeService.apicrypt);
          const accounts = await this._mssSrv.getService().listAccounts(this._idNat);
          this.addAccountsToList(MssTypeService.apicrypt, accounts);
        } catch (e) {
          console.error(e);
        }
        this.accounts = [...this.accounts];
      }

      // On vérifie l'existence qu'une messagerie MSS soit paramétrée
      this.isMSSSet = await this._isMSSSet();
      if (!this.isMSSSet) {
        return;
      }

      this.accountForm = this._formBuilder.group({
        account: ['', Validators.required]
      });
    } catch (e) {
      console.error(e);
    }
  }

  private async _isMSSSet(): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      try {
        let resourceId = '';
        const currentProfilStr = localStorage.getItem('currentProfil');
        if (currentProfilStr && currentProfilStr !== '') {
          const currentProfil = JSON.parse(currentProfilStr);
          resourceId = currentProfil.id;
        }
        if (resourceId) {
          const params = await this._resourceSrv.getResourceSettings(resourceId, 'profil');
          if (params) {
            const practiceSetting = this._getSettings(params, practiceSettingKey);
            const identifiantNationalSetting = this._getSettings(params, identifiantNationalKey);
            const professionSetting = this._getSettings(params, professionSettingKey);
            // const specialiteSetting = this._getSettings(params, specialiteSettingKey);
            const nomSetting = this._getSettings(params, nomSettingKey);
            const prenomSetting = this._getSettings(params, prenomSettingKey);
            const idnatStructureSetting = this._getSettings(params, idnatStructureSettingKey);
            const nomStructureSetting = this._getSettings(params, nomStructureSettingKey);
            const typeStructureSetting = this._getSettings(params, typeStructureSettingKey);

            resolve(!!practiceSetting && !!identifiantNationalSetting &&
              !!professionSetting && !!nomSetting &&
              !!prenomSetting && !!idnatStructureSetting && !!nomStructureSetting &&
              !!typeStructureSetting);
          }
        } else {
          resolve(false);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  private _getSettings = (params: RessourceSetting[], settingKey: string): string|undefined => {
    const temp = params.find(p => p.settingKey === settingKey);
    return temp ? temp.settingValue : undefined;
  }

  private addAccountsToList(provider: MssTypeService, accounts: Array<string>, idNat?: string): void {
    this._mssSrv.switchService(provider);
    for (const account of accounts) {
      if (!this.accounts.find(a => a.id === `${account}$${provider}$${idNat}` || a.id === `${account}$${provider}`)) {
        this.accounts.push({
          id: idNat ? `${account}$${provider}$${idNat}` : `${account}$${provider}`,
          libelle: idNat ? `${this._mssSrv.getService().providerLibellePrefix()} : ${account} (${idNat})` : `${this._mssSrv.getService().providerLibellePrefix()} : ${account}`,
        });
      }
    }

    // On switch vers le dernier provider sélectionné
    this.switchToLastSelectedProvider();
  }

  private switchToLastSelectedProvider(): void {
    this._mssSrv.switchService(this._lastProviderSelected);
  }

  public async selectAccount(): Promise<void> {
    const _setEmailAuthent = (email: string, idNat: string, provider: MssTypeService) => {
      rtd = { email, idNat, provider };
    };

    let connectionOk = false;
    this.isPending = true;
    const select = this.accountForm.get('account').value;

    let rtd: MssConnectionOk;

    if (select) {
      const selectSplit = (select as string).split('$');
      const account = selectSplit[0];
      const provider = selectSplit[1];
      const idNat = selectSplit[2];

      const lastSelectedProvider = this._lastProviderSelected;
      this._selectedIdNat = idNat;

      try {
        this._mssSrv.switchService(provider as MssTypeService);
        if ((provider as MssTypeService) === MssTypeService.mailiz) {
          if (!await this._mssSrv.getService().isSessionValid({ email: account, idNat })) {
            await new Promise<void>(async (r) => {
              const modal = this._modalSrv.openModal<ConnectToMailizComponent>(
                this._viewCtnRef,
                ConnectToMailizComponent
              ) as ComponentRef<ConnectToMailizComponent>;

              modal.instance.idNat = idNat;
              const sub = modal.instance.closeEmitter.subscribe(async (res: string) => {
                this.isPending = false;
                modal.destroy();
                sub.unsubscribe();

                if (res === 'connected') {
                  await this._saveMails(idNat, lastSelectedProvider);
                  await this._connexionOk();
                  _setEmailAuthent(account, idNat, MssTypeService.mailiz);
                  connectionOk = true;
                } else {
                  // this.userMail = currentUserMail;
                  // this.selectedIdNat = currentSelectedIdNat;
                }
                r();
              });
            });
          } else {
            await this._saveMails(idNat, lastSelectedProvider);
            await this._connexionOk();
            _setEmailAuthent(account, idNat, MssTypeService.mailiz);
            connectionOk = true;
          }
        } else if ((provider as MssTypeService) === MssTypeService.apicrypt) {
          if (!await this._mssSrv.getService().isSessionValid({ email: account, idNat })) {
            await new Promise<void>(async (r) => {
              const modal = this._modalSrv.openModal<ConnectToApicryptComponent>(
                this._viewCtnRef,
                ConnectToApicryptComponent
              ) as ComponentRef<ConnectToApicryptComponent>;
              modal.instance.inputAccount = account;
              const sub = modal.instance.closeEmitter.subscribe(async (res: string) => {
                modal.destroy();
                sub.unsubscribe();
                this.isPending = false;
  
                if (res === 'connected') {
                  await this._connexionOk();
                  _setEmailAuthent(account, idNat, MssTypeService.apicrypt);
                } else {
                  // this.userMail = currentUserMail;
                  // this.selectedIdNat = currentSelectedIdNat;
                }
                r();
              });
            });
          } else {
            await this._connexionOk();
            _setEmailAuthent(account, idNat, MssTypeService.apicrypt);
            connectionOk = true;
          }

        }
      } catch (e) {
        // await this._openAlertModal(e.message);
        // this.userMail = currentUserMail;
        // this.selectedIdNat = currentSelectedIdNat;
      }
    }

    this.isPending = false;
    this.closeModal(rtd);
  }

  private async _connexionOk(): Promise<void> {
    await this._initProvider();
  }

  private _authenticationErrorSubscription: Subscription;
  private async _initProvider(): Promise<void> {
    if (!this._authenticationErrorSubscription) {
      this._authenticationErrorSubscription = this._mssSrv.getService().authenticationErrorSubject.subscribe(async (isLogged) => {
        if (!isLogged) {
          if (this._mssSrv.getService().isTokenNeeded()) {
            this._mssSrv.getService().clearToken(this._idNat);
          }

          if (this._lastProviderSelected === MssTypeService.mailiz) {
            const modal = this._modalSrv.openModal<ConnectToMailizComponent>(
              this._viewCtnRef,
              ConnectToMailizComponent
            ) as ComponentRef<ConnectToMailizComponent>;

            modal.instance.idNat = this._selectedIdNat;
            const sub = modal.instance.closeEmitter.subscribe(async (res: string) => {
              modal.destroy();
              sub.unsubscribe();

              if (res === 'connected') {
                await this._saveMails(this._selectedIdNat, this._lastProviderSelected);
                await this._connexionOk();
              } else {
                this._selectedIdNat = undefined;
              }
            });
          } else if (this._lastProviderSelected === MssTypeService.apicrypt) {
            const modal = this._modalSrv.openModal<ConnectToApicryptComponent>(
              this._viewCtnRef,
              ConnectToApicryptComponent
            ) as ComponentRef<ConnectToApicryptComponent>;
            modal.instance.inputAccount = this._accountSelected.accountName;
            const sub = modal.instance.closeEmitter.subscribe(async (res: string) => {
              modal.destroy();
              sub.unsubscribe();

              if (res === 'connected') {
                await this._connexionOk();
              } else {
                this._selectedIdNat = undefined;
              }
            });
          }
        }
      });
    }
  }

  private async _saveMails(idNat: string, previousSelectedProvider: MssTypeService): Promise<void> {
    this._mssSrv.switchService(MssTypeService.mailiz);
    const accounts = await this._mssSrv.getService().listAccounts(idNat);
    if (accounts) {
      this.addAccountsToList(MssTypeService.mailiz, accounts, idNat);

      const settings = await this._resourceSrv.getResourceSettings(this._currentProfil.id, 'profil');
      const addressesStr = this._getSettings(settings, 'mailiz_account');
      let addresses: Array<MailizAccount> = [];
      if (addressesStr && addressesStr !== '') {
        addresses = JSON.parse(addressesStr);
        let found = false;
        for (const address of addresses) {
          if (address && address.idnat === idNat) {
            address.addresses = accounts;
            found = true;
          }
        }
        if (!found) {
          addresses.push({
            idnat: idNat,
            addresses: accounts
          });
        }
        await this._resourceSrv.postResourceSettings(this._currentProfil.id, 'profil', {
          ressourceId: this._currentProfil.id,
          ressourceType: RessourceTypeEnum.Profil,
          settingKey: `mailiz_account`,
          settingType: 'object',
          settingValue: JSON.stringify(addresses)
        });
      } else {

        const value = [{
          idnat: idNat,
          addresses: accounts
        }];
        await this._resourceSrv.postResourceSettings(this._currentProfil.id, 'profil', {
          ressourceId: this._currentProfil.id,
          ressourceType: RessourceTypeEnum.Profil,
          settingKey: `mailiz_account`,
          settingType: 'object',
          settingValue: JSON.stringify(value)
        });
      }
    }

    if (previousSelectedProvider) {
      this._mssSrv.switchService(previousSelectedProvider);
    }
  }

  public closeModal(emailAuthent?: MssConnectionOk): void {
    this.closeEmitter.emit(emailAuthent);
  }

}
